import { useMutation } from 'react-query';
import { selftapeDao } from 'shared/dao/selftapeDao';

import { ISelfTapesTermsPayload, ISelftapeTermsResponsePayload } from 'shared/interfaces/ISelfTape';
import { IAxiosErrorResponse } from 'shared/interfaces/utils/IAxios';

const { submitSelftapesTerms: submitSelftapesTermsDao } = selftapeDao();

export const selftapeService = () => {
  const submitSelftapesTerms = () => {
    return useMutation<
      ISelftapeTermsResponsePayload,
      IAxiosErrorResponse,
      { auditionId: string; payload: ISelfTapesTermsPayload }
    >(({ auditionId, payload }) => submitSelftapesTermsDao(auditionId, payload));
  };

  return {
    submitSelftapesTerms,
  };
};
